import { render, staticRenderFns } from "./viewAdminDetails.vue?vue&type=template&id=57c37ce9&scoped=true&"
import script from "./viewAdminDetails.vue?vue&type=script&lang=js&"
export * from "./viewAdminDetails.vue?vue&type=script&lang=js&"
import style0 from "./viewAdminDetails.vue?vue&type=style&index=0&id=57c37ce9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c37ce9",
  null
  
)

export default component.exports